import { initializeApp } from 'firebase/app';
import { getAuth, signInAnonymously, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, collection, addDoc, onSnapshot, serverTimestamp } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: "G-Y84DE34YF1"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export { app };

export const initFirebase = async () => {
  try {
    await signInAnonymously(auth);
    return new Promise((resolve) => {
      onAuthStateChanged(auth, (user) => {
        if (user) {
          resolve(user.uid);
        }
      });
    });
  } catch (error) {
    console.error("Firebase init error:", error);
    return null;
  }
};

export const saveAnalysis = async (userId, query, result, type) => {
  if (!db || !userId) return;
  
  try {
    const analysisRef = collection(db, `artifacts/${firebaseConfig.appId}/users/${userId}/waltz_analysis`);
    await addDoc(analysisRef, {
      query,
      result,
      type,
      timestamp: serverTimestamp()
    });
  } catch (error) {
    console.error("Error saving analysis:", error);
  }
};

export const subscribeToHistory = (userId, callback) => {
  if (!db || !userId) return () => {};
  
  const analysisRef = collection(db, `artifacts/${firebaseConfig.appId}/users/${userId}/waltz_analysis`);
  return onSnapshot(analysisRef, (snapshot) => {
    const analyses = [];
    snapshot.forEach((doc) => analyses.push(doc.data()));
    callback(analyses);
  });
};
